import { jsxs as V, jsx as h, Fragment as oe } from "react/jsx-runtime";
import ct, { createContext as I, useLayoutEffect as ut, useEffect as T, useContext as P, useRef as x, useInsertionEffect as _e, useCallback as lt, useMemo as R, forwardRef as dt, Fragment as Fe, createElement as ft, useState as ke } from "react";
import { d as mt } from "../number-DiuiLCOa.js";
import { c as ht } from "../index-Cu0xwYjD.js";
import { useResizeObserver as De } from "../Hooks/useResizeObserver.js";
import { w as pt, r as gt, x as ae, o as Ne, y as H, z as je, A as se, B as we, C as Be, D as yt, i as N, E as vt, F as E, I as bt, J as He, K as wt, L as We, M as te, N as Pt, l as At, u as ce, O as Vt, P as St, Q as Ct, R as Ge, T as Ue, U as xt, W as Mt, X as Lt, Y as Rt, S as Tt, H as Et, b as Ot, Z as It, _ as _t, $ as X, a0 as Ft, a1 as kt, a2 as Dt } from "../SVGVisualElement-Cn0-2e7g.js";
const Nt = "_chart_168q4_1", jt = "_priceLabelWrapper_168q4_6", Bt = "_priceLabel_168q4_6", Ht = "_quartileLabel_168q4_27", Wt = "_priceRange_168q4_34", Gt = "_priceRangeLabel_168q4_38", Ut = "_priceRangeValue_168q4_47", S = {
  chart: Nt,
  priceLabelWrapper: jt,
  priceLabel: Bt,
  quartileLabel: Ht,
  priceRange: Wt,
  priceRangeLabel: Gt,
  priceRangeValue: Ut
};
function qt(e) {
  if (typeof Proxy > "u")
    return e;
  const t = /* @__PURE__ */ new Map(), n = (...r) => (process.env.NODE_ENV !== "production" && pt(!1, "motion() is deprecated. Use motion.create() instead."), e(...r));
  return new Proxy(n, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (r, i) => i === "create" ? e : (t.has(i) || t.set(i, e(i)), t.get(i))
  });
}
function qe(e, t) {
  if (!Array.isArray(t))
    return !1;
  const n = t.length;
  if (n !== e.length)
    return !1;
  for (let r = 0; r < n; r++)
    if (t[r] !== e[r])
      return !1;
  return !0;
}
const Kt = {
  x: !1,
  y: !1
};
function $t() {
  return Kt.y;
}
function Ke(e, t) {
  const n = gt(e), r = new AbortController(), i = {
    passive: !0,
    ...t,
    signal: r.signal
  };
  return [n, i, () => r.abort()];
}
function Pe(e) {
  return (t) => {
    t.pointerType === "touch" || $t() || e(t);
  };
}
function zt(e, t, n = {}) {
  const [r, i, o] = Ke(e, n), s = Pe((u) => {
    const { target: l } = u, a = t(u);
    if (!a || !l)
      return;
    const f = Pe((d) => {
      a(d), l.removeEventListener("pointerleave", f);
    });
    l.addEventListener("pointerleave", f, i);
  });
  return r.forEach((u) => {
    u.addEventListener("pointerenter", s, i);
  }), o;
}
const Yt = (e) => e.pointerType === "mouse" ? typeof e.button != "number" || e.button <= 0 : e.isPrimary !== !1, D = /* @__PURE__ */ new WeakSet();
function Ae(e) {
  return (t) => {
    t.key === "Enter" && e(t);
  };
}
function J(e, t) {
  e.dispatchEvent(new PointerEvent("pointer" + t, { isPrimary: !0, bubbles: !0 }));
}
const Xt = (e, t) => {
  const n = e.currentTarget;
  if (!n)
    return;
  const r = Ae(() => {
    if (D.has(n))
      return;
    J(n, "down");
    const i = Ae(() => {
      J(n, "up");
    }), o = () => J(n, "cancel");
    n.addEventListener("keyup", i, t), n.addEventListener("blur", o, t);
  });
  n.addEventListener("keydown", r, t), n.addEventListener("blur", () => n.removeEventListener("keydown", r), t);
}, Jt = /* @__PURE__ */ new Set([
  "BUTTON",
  "INPUT",
  "SELECT",
  "TEXTAREA",
  "A"
]);
function Qt(e) {
  return Jt.has(e.tagName) || e.tabIndex !== -1;
}
const $e = (e, t) => t ? e === t ? !0 : $e(e, t.parentElement) : !1;
function Ve(e) {
  return Yt(e) && !0;
}
function Zt(e, t, n = {}) {
  const [r, i, o] = Ke(e, n), s = (u) => {
    const l = u.currentTarget;
    if (!Ve(u) || D.has(l))
      return;
    D.add(l);
    const a = t(u), f = (m, v) => {
      window.removeEventListener("pointerup", d), window.removeEventListener("pointercancel", c), !(!Ve(m) || !D.has(l)) && (D.delete(l), a && a(m, { success: v }));
    }, d = (m) => {
      f(m, n.useGlobalTarget || $e(l, m.target));
    }, c = (m) => {
      f(m, !1);
    };
    window.addEventListener("pointerup", d, i), window.addEventListener("pointercancel", c, i);
  };
  return r.forEach((u) => {
    Qt(u) || (u.tabIndex = 0), (n.useGlobalTarget ? window : u).addEventListener("pointerdown", s, i), u.addEventListener("focus", (a) => Xt(a, i), i);
  }), o;
}
function ne(e, t, n = {}) {
  var r;
  const i = ae(e, t, n.type === "exit" ? (r = e.presenceContext) === null || r === void 0 ? void 0 : r.custom : void 0);
  let { transition: o = e.getDefaultTransition() || {} } = i || {};
  n.transitionOverride && (o = n.transitionOverride);
  const s = i ? () => Promise.all(Ne(e, i, n)) : () => Promise.resolve(), u = e.variantChildren && e.variantChildren.size ? (a = 0) => {
    const { delayChildren: f = 0, staggerChildren: d, staggerDirection: c } = o;
    return en(e, t, f + a, d, c, n);
  } : () => Promise.resolve(), { when: l } = o;
  if (l) {
    const [a, f] = l === "beforeChildren" ? [s, u] : [u, s];
    return a().then(() => f());
  } else
    return Promise.all([s(), u(n.delay)]);
}
function en(e, t, n = 0, r = 0, i = 1, o) {
  const s = [], u = (e.variantChildren.size - 1) * r, l = i === 1 ? (a = 0) => a * r : (a = 0) => u - a * r;
  return Array.from(e.variantChildren).sort(tn).forEach((a, f) => {
    a.notify("AnimationStart", t), s.push(ne(a, t, {
      ...o,
      delay: n + l(f)
    }).then(() => a.notify("AnimationComplete", t)));
  }), Promise.all(s);
}
function tn(e, t) {
  return e.sortNodePosition(t);
}
function nn(e, t, n = {}) {
  e.notify("AnimationStart", t);
  let r;
  if (Array.isArray(t)) {
    const i = t.map((o) => ne(e, o, n));
    r = Promise.all(i);
  } else if (typeof t == "string")
    r = ne(e, t, n);
  else {
    const i = typeof t == "function" ? ae(e, t, n.custom) : t;
    r = Promise.all(Ne(e, i, n));
  }
  return r.then(() => {
    e.notify("AnimationComplete", t);
  });
}
const rn = je.length;
function ze(e) {
  if (!e)
    return;
  if (!e.isControllingVariants) {
    const n = e.parent ? ze(e.parent) || {} : {};
    return e.props.initial !== void 0 && (n.initial = e.props.initial), n;
  }
  const t = {};
  for (let n = 0; n < rn; n++) {
    const r = je[n], i = e.props[r];
    (H(i) || i === !1) && (t[r] = i);
  }
  return t;
}
const on = [...Be].reverse(), an = Be.length;
function sn(e) {
  return (t) => Promise.all(t.map(({ animation: n, options: r }) => nn(e, n, r)));
}
function cn(e) {
  let t = sn(e), n = Se(), r = !0;
  const i = (l) => (a, f) => {
    var d;
    const c = ae(e, f, l === "exit" ? (d = e.presenceContext) === null || d === void 0 ? void 0 : d.custom : void 0);
    if (c) {
      const { transition: m, transitionEnd: v, ...A } = c;
      a = { ...a, ...A, ...v };
    }
    return a;
  };
  function o(l) {
    t = l(e);
  }
  function s(l) {
    const { props: a } = e, f = ze(e.parent) || {}, d = [], c = /* @__PURE__ */ new Set();
    let m = {}, v = 1 / 0;
    for (let w = 0; w < an; w++) {
      const g = on[w], p = n[g], y = a[g] !== void 0 ? a[g] : f[g], F = H(y), K = g === l ? p.isActive : null;
      K === !1 && (v = w);
      let j = y === f[g] && y !== a[g] && F;
      if (j && r && e.manuallyAnimateOnMount && (j = !1), p.protectedKeys = { ...m }, // If it isn't active and hasn't *just* been set as inactive
      !p.isActive && K === null || // If we didn't and don't have any defined prop for this animation type
      !y && !p.prevProp || // Or if the prop doesn't define an animation
      se(y) || typeof y == "boolean")
        continue;
      const pe = un(p.prevProp, y);
      let $ = pe || // If we're making this variant active, we want to always make it active
      g === l && p.isActive && !j && F || // If we removed a higher-priority variant (i is in reverse order)
      w > v && F, ge = !1;
      const ye = Array.isArray(y) ? y : [y];
      let k = ye.reduce(i(g), {});
      K === !1 && (k = {});
      const { prevResolvedValues: ve = {} } = p, st = {
        ...ve,
        ...k
      }, be = (b) => {
        $ = !0, c.has(b) && (ge = !0, c.delete(b)), p.needsAnimating[b] = !0;
        const C = e.getValue(b);
        C && (C.liveStyle = !1);
      };
      for (const b in st) {
        const C = k[b], z = ve[b];
        if (m.hasOwnProperty(b))
          continue;
        let Y = !1;
        we(C) && we(z) ? Y = !qe(C, z) : Y = C !== z, Y ? C != null ? be(b) : c.add(b) : C !== void 0 && c.has(b) ? be(b) : p.protectedKeys[b] = !0;
      }
      p.prevProp = y, p.prevResolvedValues = k, p.isActive && (m = { ...m, ...k }), r && e.blockInitialAnimation && ($ = !1), $ && (!(j && pe) || ge) && d.push(...ye.map((b) => ({
        animation: b,
        options: { type: g }
      })));
    }
    if (c.size) {
      const w = {};
      c.forEach((g) => {
        const p = e.getBaseTarget(g), y = e.getValue(g);
        y && (y.liveStyle = !0), w[g] = p ?? null;
      }), d.push({ animation: w });
    }
    let A = !!d.length;
    return r && (a.initial === !1 || a.initial === a.animate) && !e.manuallyAnimateOnMount && (A = !1), r = !1, A ? t(d) : Promise.resolve();
  }
  function u(l, a) {
    var f;
    if (n[l].isActive === a)
      return Promise.resolve();
    (f = e.variantChildren) === null || f === void 0 || f.forEach((c) => {
      var m;
      return (m = c.animationState) === null || m === void 0 ? void 0 : m.setActive(l, a);
    }), n[l].isActive = a;
    const d = s(l);
    for (const c in n)
      n[c].protectedKeys = {};
    return d;
  }
  return {
    animateChanges: s,
    setActive: u,
    setAnimateFunction: o,
    getState: () => n,
    reset: () => {
      n = Se(), r = !0;
    }
  };
}
function un(e, t) {
  return typeof t == "string" ? t !== e : Array.isArray(t) ? !qe(t, e) : !1;
}
function L(e = !1) {
  return {
    isActive: e,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function Se() {
  return {
    animate: L(!0),
    whileInView: L(),
    whileHover: L(),
    whileTap: L(),
    whileDrag: L(),
    whileFocus: L(),
    exit: L()
  };
}
class _ {
  constructor(t) {
    this.isMounted = !1, this.node = t;
  }
  update() {
  }
}
class ln extends _ {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(t) {
    super(t), t.animationState || (t.animationState = cn(t));
  }
  updateAnimationControlsSubscription() {
    const { animate: t } = this.node.getProps();
    se(t) && (this.unmountControls = t.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: t } = this.node.getProps(), { animate: n } = this.node.prevProps || {};
    t !== n && this.updateAnimationControlsSubscription();
  }
  unmount() {
    var t;
    this.node.animationState.reset(), (t = this.unmountControls) === null || t === void 0 || t.call(this);
  }
}
let dn = 0;
class fn extends _ {
  constructor() {
    super(...arguments), this.id = dn++;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent: t, onExitComplete: n } = this.node.presenceContext, { isPresent: r } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || t === r)
      return;
    const i = this.node.animationState.setActive("exit", !t);
    n && !t && i.then(() => n(this.id));
  }
  mount() {
    const { register: t } = this.node.presenceContext || {};
    t && (this.unmount = t(this.id));
  }
  unmount() {
  }
}
const mn = {
  animation: {
    Feature: ln
  },
  exit: {
    Feature: fn
  }
};
function Ce(e, t, n, r = { passive: !0 }) {
  return e.addEventListener(t, n, r), () => e.removeEventListener(t, n);
}
function Ye(e) {
  return {
    point: {
      x: e.pageX,
      y: e.pageY
    }
  };
}
function Xe(e) {
  return e && typeof e == "object" && Object.prototype.hasOwnProperty.call(e, "current");
}
const Je = I(null), hn = I({}), pn = I({}), { schedule: gn, cancel: Mr } = yt(queueMicrotask, !1);
function yn(e) {
  const t = N(e) ? e.get() : e;
  return vt(t) ? t.toValue() : t;
}
function xe(e, t, n) {
  const { props: r } = e;
  e.animationState && r.whileHover && e.animationState.setActive("whileHover", n === "Start");
  const i = "onHover" + n, o = r[i];
  o && E.postRender(() => o(t, Ye(t)));
}
class vn extends _ {
  mount() {
    const { current: t } = this.node;
    t && (this.unmount = zt(t, (n) => (xe(this.node, n, "Start"), (r) => xe(this.node, r, "End"))));
  }
  unmount() {
  }
}
class bn extends _ {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let t = !1;
    try {
      t = this.node.current.matches(":focus-visible");
    } catch {
      t = !0;
    }
    !t || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = bt(Ce(this.node.current, "focus", () => this.onFocus()), Ce(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
function Me(e, t, n) {
  const { props: r } = e;
  e.animationState && r.whileTap && e.animationState.setActive("whileTap", n === "Start");
  const i = "onTap" + (n === "End" ? "" : n), o = r[i];
  o && E.postRender(() => o(t, Ye(t)));
}
class wn extends _ {
  mount() {
    const { current: t } = this.node;
    t && (this.unmount = Zt(t, (n) => (Me(this.node, n, "Start"), (r, { success: i }) => Me(this.node, r, i ? "End" : "Cancel")), { useGlobalTarget: this.node.props.globalTapTarget }));
  }
  unmount() {
  }
}
const re = /* @__PURE__ */ new WeakMap(), Q = /* @__PURE__ */ new WeakMap(), Pn = (e) => {
  const t = re.get(e.target);
  t && t(e);
}, An = (e) => {
  e.forEach(Pn);
};
function Vn({ root: e, ...t }) {
  const n = e || document;
  Q.has(n) || Q.set(n, {});
  const r = Q.get(n), i = JSON.stringify(t);
  return r[i] || (r[i] = new IntersectionObserver(An, { root: e, ...t })), r[i];
}
function Sn(e, t, n) {
  const r = Vn(t);
  return re.set(e, n), r.observe(e), () => {
    re.delete(e), r.unobserve(e);
  };
}
const Cn = {
  some: 0,
  all: 1
};
class xn extends _ {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    this.unmount();
    const { viewport: t = {} } = this.node.getProps(), { root: n, margin: r, amount: i = "some", once: o } = t, s = {
      root: n ? n.current : void 0,
      rootMargin: r,
      threshold: typeof i == "number" ? i : Cn[i]
    }, u = (l) => {
      const { isIntersecting: a } = l;
      if (this.isInView === a || (this.isInView = a, o && !a && this.hasEnteredView))
        return;
      a && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", a);
      const { onViewportEnter: f, onViewportLeave: d } = this.node.getProps(), c = a ? f : d;
      c && c(l);
    };
    return Sn(this.node.current, s, u);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props: t, prevProps: n } = this.node;
    ["amount", "margin", "root"].some(Mn(t, n)) && this.startObserver();
  }
  unmount() {
  }
}
function Mn({ viewport: e = {} }, { viewport: t = {} } = {}) {
  return (n) => e[n] !== t[n];
}
const Ln = {
  inView: {
    Feature: xn
  },
  tap: {
    Feature: wn
  },
  focus: {
    Feature: bn
  },
  hover: {
    Feature: vn
  }
}, U = I({
  transformPagePoint: (e) => e,
  isStatic: !1,
  reducedMotion: "never"
}), q = I({}), ue = He ? ut : T, le = I({ strict: !1 });
function Rn(e, t, n, r, i) {
  var o, s;
  const { visualElement: u } = P(q), l = P(le), a = P(Je), f = P(U).reducedMotion, d = x(null);
  r = r || l.renderer, !d.current && r && (d.current = r(e, {
    visualState: t,
    parent: u,
    props: n,
    presenceContext: a,
    blockInitialAnimation: a ? a.initial === !1 : !1,
    reducedMotionConfig: f
  }));
  const c = d.current, m = P(pn);
  c && !c.projection && i && (c.type === "html" || c.type === "svg") && Tn(d.current, n, i, m);
  const v = x(!1);
  _e(() => {
    c && v.current && c.update(n, a);
  });
  const A = n[wt], w = x(!!A && !(!((o = window.MotionHandoffIsComplete) === null || o === void 0) && o.call(window, A)) && ((s = window.MotionHasOptimisedAnimation) === null || s === void 0 ? void 0 : s.call(window, A)));
  return ue(() => {
    c && (v.current = !0, window.MotionIsMounted = !0, c.updateFeatures(), gn.render(c.render), w.current && c.animationState && c.animationState.animateChanges());
  }), T(() => {
    c && (!w.current && c.animationState && c.animationState.animateChanges(), w.current && (queueMicrotask(() => {
      var g;
      (g = window.MotionHandoffMarkAsComplete) === null || g === void 0 || g.call(window, A);
    }), w.current = !1));
  }), c;
}
function Tn(e, t, n, r) {
  const { layoutId: i, layout: o, drag: s, dragConstraints: u, layoutScroll: l, layoutRoot: a } = t;
  e.projection = new n(e.latestValues, t["data-framer-portal-id"] ? void 0 : Qe(e.parent)), e.projection.setOptions({
    layoutId: i,
    layout: o,
    alwaysMeasureLayout: !!s || u && Xe(u),
    visualElement: e,
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof o == "string" ? o : "both",
    initialPromotionConfig: r,
    layoutScroll: l,
    layoutRoot: a
  });
}
function Qe(e) {
  if (e)
    return e.options.allowProjection !== !1 ? e.projection : Qe(e.parent);
}
function En(e, t, n) {
  return lt(
    (r) => {
      r && e.mount && e.mount(r), t && (r ? t.mount(r) : t.unmount()), n && (typeof n == "function" ? n(r) : Xe(n) && (n.current = r));
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [t]
  );
}
function On(e, t) {
  if (We(e)) {
    const { initial: n, animate: r } = e;
    return {
      initial: n === !1 || H(n) ? n : void 0,
      animate: H(r) ? r : void 0
    };
  }
  return e.inherit !== !1 ? t : {};
}
function In(e) {
  const { initial: t, animate: n } = On(e, P(q));
  return R(() => ({ initial: t, animate: n }), [Le(t), Le(n)]);
}
function Le(e) {
  return Array.isArray(e) ? e.join(" ") : e;
}
function ie(e) {
  for (const t in e)
    te[t] = {
      ...te[t],
      ...e[t]
    };
}
const _n = Symbol.for("motionComponentSymbol");
function Fn({ preloadedFeatures: e, createVisualElement: t, useRender: n, useVisualState: r, Component: i }) {
  e && ie(e);
  function o(u, l) {
    let a;
    const f = {
      ...P(U),
      ...u,
      layoutId: kn(u)
    }, { isStatic: d } = f, c = In(u), m = r(u, d);
    if (!d && He) {
      Dn(f, e);
      const v = Nn(f);
      a = v.MeasureLayout, c.visualElement = Rn(i, m, f, t, v.ProjectionNode);
    }
    return V(q.Provider, { value: c, children: [a && c.visualElement ? h(a, { visualElement: c.visualElement, ...f }) : null, n(i, u, En(m, c.visualElement, l), m, d, c.visualElement)] });
  }
  const s = dt(o);
  return s[_n] = i, s;
}
function kn({ layoutId: e }) {
  const t = P(hn).id;
  return t && e !== void 0 ? t + "-" + e : e;
}
function Dn(e, t) {
  const n = P(le).strict;
  if (process.env.NODE_ENV !== "production" && t && n) {
    const r = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
    e.ignoreStrict ? Pt(!1, r) : At(!1, r);
  }
}
function Nn(e) {
  const { drag: t, layout: n } = te;
  if (!t && !n)
    return {};
  const r = { ...t, ...n };
  return {
    MeasureLayout: t != null && t.isEnabled(e) || n != null && n.isEnabled(e) ? r.MeasureLayout : void 0,
    ProjectionNode: r.ProjectionNode
  };
}
const jn = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function de(e) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof e != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    e.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(jn.indexOf(e) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/u.test(e))
    )
  );
}
function Bn({ scrapeMotionValuesFromProps: e, createRenderState: t, onMount: n }, r, i, o) {
  const s = {
    latestValues: Hn(r, i, o, e),
    renderState: t()
  };
  return n && (s.mount = (u) => n(r, u, s)), s;
}
const Ze = (e) => (t, n) => {
  const r = P(q), i = P(Je), o = () => Bn(e, t, r, i);
  return n ? o() : ce(o);
};
function Hn(e, t, n, r) {
  const i = {}, o = r(e, {});
  for (const c in o)
    i[c] = yn(o[c]);
  let { initial: s, animate: u } = e;
  const l = We(e), a = Vt(e);
  t && a && !l && e.inherit !== !1 && (s === void 0 && (s = t.initial), u === void 0 && (u = t.animate));
  let f = n ? n.initial === !1 : !1;
  f = f || s === !1;
  const d = f ? u : s;
  if (d && typeof d != "boolean" && !se(d)) {
    const c = Array.isArray(d) ? d : [d];
    for (let m = 0; m < c.length; m++) {
      const v = St(e, c[m]);
      if (v) {
        const { transitionEnd: A, transition: w, ...g } = v;
        for (const p in g) {
          let y = g[p];
          if (Array.isArray(y)) {
            const F = f ? y.length - 1 : 0;
            y = y[F];
          }
          y !== null && (i[p] = y);
        }
        for (const p in A)
          i[p] = A[p];
      }
    }
  }
  return i;
}
const fe = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
}), et = () => ({
  ...fe(),
  attrs: {}
}), Wn = {
  useVisualState: Ze({
    scrapeMotionValuesFromProps: Ct,
    createRenderState: et,
    onMount: (e, t, { renderState: n, latestValues: r }) => {
      E.read(() => {
        try {
          n.dimensions = typeof t.getBBox == "function" ? t.getBBox() : t.getBoundingClientRect();
        } catch {
          n.dimensions = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
          };
        }
      }), E.render(() => {
        Ge(n, r, Ue(t.tagName), e.transformTemplate), xt(t, n);
      });
    }
  })
}, Gn = {
  useVisualState: Ze({
    scrapeMotionValuesFromProps: Mt,
    createRenderState: fe
  })
};
function tt(e, t, n) {
  for (const r in t)
    !N(t[r]) && !Lt(r, n) && (e[r] = t[r]);
}
function Un({ transformTemplate: e }, t) {
  return R(() => {
    const n = fe();
    return Rt(n, t, e), Object.assign({}, n.vars, n.style);
  }, [t]);
}
function qn(e, t) {
  const n = e.style || {}, r = {};
  return tt(r, n, e), Object.assign(r, Un(e, t)), r;
}
function Kn(e, t) {
  const n = {}, r = qn(e, t);
  return e.drag && e.dragListener !== !1 && (n.draggable = !1, r.userSelect = r.WebkitUserSelect = r.WebkitTouchCallout = "none", r.touchAction = e.drag === !0 ? "none" : `pan-${e.drag === "x" ? "y" : "x"}`), e.tabIndex === void 0 && (e.onTap || e.onTapStart || e.whileTap) && (n.tabIndex = 0), n.style = r, n;
}
const $n = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "ignoreStrict",
  "viewport"
]);
function W(e) {
  return e.startsWith("while") || e.startsWith("drag") && e !== "draggable" || e.startsWith("layout") || e.startsWith("onTap") || e.startsWith("onPan") || e.startsWith("onLayout") || $n.has(e);
}
let nt = (e) => !W(e);
function zn(e) {
  e && (nt = (t) => t.startsWith("on") ? !W(t) : e(t));
}
try {
  zn(require("@emotion/is-prop-valid").default);
} catch {
}
function Yn(e, t, n) {
  const r = {};
  for (const i in e)
    i === "values" && typeof e.values == "object" || (nt(i) || n === !0 && W(i) || !t && !W(i) || // If trying to use native HTML drag events, forward drag listeners
    e.draggable && i.startsWith("onDrag")) && (r[i] = e[i]);
  return r;
}
function Xn(e, t, n, r) {
  const i = R(() => {
    const o = et();
    return Ge(o, t, Ue(r), e.transformTemplate), {
      ...o.attrs,
      style: { ...o.style }
    };
  }, [t]);
  if (e.style) {
    const o = {};
    tt(o, e.style, e), i.style = { ...o, ...i.style };
  }
  return i;
}
function Jn(e = !1) {
  return (n, r, i, { latestValues: o }, s) => {
    const l = (de(n) ? Xn : Kn)(r, o, s, n), a = Yn(r, typeof n == "string", e), f = n !== Fe ? { ...a, ...l, ref: i } : {}, { children: d } = r, c = R(() => N(d) ? d.get() : d, [d]);
    return ft(n, {
      ...f,
      children: c
    });
  };
}
function Qn(e, t) {
  return function(r, { forwardMotionProps: i } = { forwardMotionProps: !1 }) {
    const s = {
      ...de(r) ? Wn : Gn,
      preloadedFeatures: e,
      useRender: Jn(i),
      createVisualElement: t,
      Component: r
    };
    return Fn(s);
  };
}
const Zn = (e, t) => de(e) ? new Tt(t) : new Et(t, {
  allowProjection: e !== Fe
}), er = /* @__PURE__ */ Qn(), O = /* @__PURE__ */ qt(er);
function tr({ children: e, features: t, strict: n = !1 }) {
  const [, r] = ke(!Z(t)), i = x(void 0);
  if (!Z(t)) {
    const { renderer: o, ...s } = t;
    i.current = o, ie(s);
  }
  return T(() => {
    Z(t) && t().then(({ renderer: o, ...s }) => {
      ie(s), i.current = o, r(!0);
    });
  }, []), h(le.Provider, { value: { renderer: i.current, strict: n }, children: e });
}
function Z(e) {
  return typeof e == "function";
}
const nr = {
  renderer: Zn,
  ...mn,
  ...Ln
};
function rt(e) {
  const t = ce(() => Ot(e)), { isStatic: n } = P(U);
  if (n) {
    const [, r] = ke(e);
    T(() => t.on("change", r), []);
  }
  return t;
}
function it(e, t) {
  const n = rt(t()), r = () => n.set(t());
  return r(), ue(() => {
    const i = () => E.preRender(r, !1, !0), o = e.map((s) => s.on("change", i));
    return () => {
      o.forEach((s) => s()), It(r);
    };
  }), n;
}
const rr = (e) => e && typeof e == "object" && e.mix, ir = (e) => rr(e) ? e.mix : void 0;
function or(...e) {
  const t = !Array.isArray(e[0]), n = t ? 0 : -1, r = e[0 + n], i = e[1 + n], o = e[2 + n], s = e[3 + n], u = _t(i, o, {
    mixer: ir(o[0]),
    ...s
  });
  return t ? u(r) : u;
}
function ar(e) {
  X.current = [], e();
  const t = it(X.current, e);
  return X.current = void 0, t;
}
function B(e, t, n, r) {
  if (typeof e == "function")
    return ar(e);
  const i = or(t, n, r);
  return Array.isArray(e) ? Re(e, i) : Re([e], ([o]) => i(o));
}
function Re(e, t) {
  const n = ce(() => []);
  return it(e, () => {
    n.length = 0;
    const r = e.length;
    for (let i = 0; i < r; i++)
      n[i] = e[i].get();
    return t(n);
  });
}
function Te(e) {
  return typeof e == "number" ? e : parseFloat(e);
}
function sr(e, t = {}) {
  const { isStatic: n } = P(U), r = x(null), i = rt(N(e) ? Te(e.get()) : e), o = x(i.get()), s = x(() => {
  }), u = () => {
    const a = r.current;
    a && a.time === 0 && a.sample(Ft.delta), l(), r.current = kt({
      keyframes: [i.get(), o.current],
      velocity: i.getVelocity(),
      type: "spring",
      restDelta: 1e-3,
      restSpeed: 0.01,
      ...t,
      onUpdate: s.current
    });
  }, l = () => {
    r.current && r.current.stop();
  };
  return _e(() => i.attach((a, f) => n ? f(a) : (o.current = a, s.current = f, E.update(u), i.get()), l), [JSON.stringify(t)]), ue(() => {
    if (N(e))
      return e.on("change", (a) => i.set(Te(a)));
  }, [i]), i;
}
const me = 100, M = 171, ot = 5, Ee = 100, at = 20, cr = M + ot, ur = me + M + ot + at;
function Lr(e) {
  const t = x(null), { width: n } = De({ ref: t }) ?? { width: 0 };
  return ct.useEffect(() => {
    Dt.skipAnimations = e.skipAnimations ?? !1;
  }, [e.skipAnimations]), /* @__PURE__ */ h(
    "svg",
    {
      width: "100%",
      height: ur,
      fill: "none",
      className: ht(S.chart, e.className),
      ref: t,
      children: n ? /* @__PURE__ */ V(tr, { features: nr, strict: !0, children: [
        /* @__PURE__ */ h(lr, { width: n }),
        /* @__PURE__ */ h(
          O.foreignObject,
          {
            initial: { opacity: 0 },
            animate: { opacity: 1 },
            transition: { duration: 1, delay: 0.5 },
            x: n / 2 - Oe / 2,
            y: "10",
            width: Oe,
            height: "60",
            children: /* @__PURE__ */ h(dr, { ...e })
          }
        ),
        /* @__PURE__ */ V("g", { transform: `translate(0, ${me})`, children: [
          /* @__PURE__ */ h(ee, { q: 0.25, width: n }),
          /* @__PURE__ */ h(ee, { q: 0.5, width: n }),
          /* @__PURE__ */ h(ee, { q: 0.75, width: n }),
          /* @__PURE__ */ h(fr, { width: n }),
          /* @__PURE__ */ h(mr, { ...e, width: n })
        ] })
      ] }) : null
    }
  );
}
const lr = ({ width: e }) => /* @__PURE__ */ V(oe, { children: [
  /* @__PURE__ */ V(
    "linearGradient",
    {
      id: "highlighted_gradient",
      x1: "348.832",
      y1: "260",
      x2: "348.832",
      y2: "1.53137e-05",
      gradientUnits: "userSpaceOnUse",
      children: [
        /* @__PURE__ */ h("stop", { stopColor: "var(--vivid-next-primary-highlight, var(--vivid-primary-highlight))" }),
        /* @__PURE__ */ h("stop", { offset: "1", stopColor: "white" })
      ]
    }
  ),
  /* @__PURE__ */ h(
    O.rect,
    {
      initial: { opacity: 0 },
      animate: { opacity: 1 },
      transition: { duration: 1.5, delay: 0.3 },
      x: e / 4,
      y: "0",
      width: e / 2,
      height: me + M,
      fill: "url(#highlighted_gradient)"
    }
  )
] }), Oe = 400, dr = ({ q1: e, q3: t, valueDimensionType: n }) => {
  switch (n) {
    case "TotalContractPrice": {
      const [r, i] = mt(e, t);
      return /* @__PURE__ */ V("div", { className: S.priceRange, children: [
        /* @__PURE__ */ h("div", { className: S.priceRangeLabel, children: "Most customers pay between" }),
        /* @__PURE__ */ V("div", { className: S.priceRangeValue, children: [
          r,
          " - ",
          i
        ] })
      ] });
    }
    case "DiscountPercent":
      return /* @__PURE__ */ V("div", { className: S.priceRange, children: [
        /* @__PURE__ */ h("div", { className: S.priceRangeLabel, children: "Most customers receive a discount between" }),
        /* @__PURE__ */ V("div", { className: S.priceRangeValue, children: [
          G(e),
          " - ",
          G(t)
        ] })
      ] });
  }
}, ee = ({ q: e, width: t }) => {
  const { x: n, y: r } = R(() => {
    const i = t * e, o = he(i, t, M);
    return { x: i, y: o };
  }, [e, t]);
  return /* @__PURE__ */ V(oe, { children: [
    /* @__PURE__ */ h(
      O.line,
      {
        initial: { y2: r },
        animate: { y2: M },
        transition: { delay: e + 0.5, duration: 0.5 },
        x1: n,
        x2: n,
        y1: r,
        strokeWidth: 1,
        stroke: "var(--vivid-next-primary-core, var(--vivid-primary-core))",
        strokeDasharray: "4 4"
      }
    ),
    /* @__PURE__ */ h(
      O.foreignObject,
      {
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        transition: { delay: e + 1 },
        x: n - Ee / 2,
        y: cr,
        width: Ee,
        height: at,
        children: /* @__PURE__ */ h("div", { className: S.quartileLabel, children: e > 0.49 && e < 0.51 ? "MEDIAN" : G(e * 100) })
      }
    )
  ] });
}, fr = ({ width: e }) => {
  const t = R(() => gr(e, M), [e]);
  return /* @__PURE__ */ h(
    "path",
    {
      d: t,
      stroke: "var(--vivid-next-primary-active, var(--vivid-primary-active))"
    }
  );
}, Ie = 25, mr = ({
  valueDimensionType: e,
  value: t,
  currencyCode: n,
  width: r,
  percentile: i,
  skipAnimations: o
}) => {
  const s = R(
    () => o ? "jump" : "set",
    // `jump` updates the value without a spring animation
    [o]
  ), u = sr(0, {
    stiffness: 16,
    damping: 12
  });
  T(() => {
    r && u[s](r * (i / 100));
  }, [u, s, r, i]);
  const l = B(() => he(u.get(), r, M)), a = B(() => M - l.get());
  T(() => {
    u[s](r * (i / 100));
  }, [u, s, r, i]);
  const f = x(null), { width: d } = De({ ref: f }) ?? {
    width: 160
  }, c = 6, m = B(
    () => Math.max(
      -3,
      Math.min(u.get() - d / 2, r - d + c / 2)
    )
  ), v = B(() => l.get() - Ie + c);
  return /* @__PURE__ */ V(oe, { children: [
    /* @__PURE__ */ h(
      O.rect,
      {
        style: { x: u, y: l, height: a },
        width: "1",
        fill: "var(--vivid-next-primary-core, var(--vivid-primary-core))"
      }
    ),
    /* @__PURE__ */ h(
      O.foreignObject,
      {
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        style: { x: m, y: v },
        width: d,
        height: Ie,
        children: /* @__PURE__ */ h("div", { className: S.priceLabelWrapper, children: /* @__PURE__ */ h("div", { className: S.priceLabel, ref: f, children: (() => {
          switch (e) {
            case "TotalContractPrice":
              return yr(n, t);
            case "DiscountPercent":
              return `You got a ${G(t)} discount`;
          }
        })() }) })
      }
    )
  ] });
}, hr = 0.16;
function he(e, t, n) {
  if (t === 0) return 0;
  const r = t / 2, i = t * hr;
  return n - n * Math.exp(-0.5 * Math.pow((e - r) / i, 2));
}
const pr = 5;
function gr(e, t) {
  let n = `M 0 ${t}`;
  for (let r = 0; r <= e; r += pr)
    n += `L${r} ${he(r, e, t)}`;
  return n;
}
const yr = (e, t) => new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: e,
  maximumFractionDigits: 0
}).format(t), vr = new Intl.NumberFormat("en-US", {
  style: "percent",
  maximumFractionDigits: 0
}), G = (e) => vr.format(e / 100);
export {
  Lr as default
};
